/* eslint-disable max-len */
var UI_CHECKMARK = {
  "default": 'M31.58,6.61l-18,21.05a1.74,1.74,0,0,1-1.2.61,1.77,1.77,0,0,1-1.28-.43L.6,18.7h0a1.75,1.75,0,0,1,2.3-2.64l9.16,8L28.92,4.34a1.75,1.75,0,0,1,2.66,2.27Z',
  globetrotter: 'M29.5 6L12.44 26L2.5 17.31'
};

export { UI_CHECKMARK };
//# sourceMappingURL=UI_CHECKMARK.js.map
